import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import OrganizationAuctionLimitsPage from '@features/admin/organizations/auctionLimits/OrganizationAuctionLimitsPage.tsx';
import { useAdminOrganizationDetailStore } from '@features/admin/organizations/useAdminOrganizationDetailStore.ts';

const paramsSchema = z.object({
  organizationId: z.coerce.number().positive(),
});

export const Route = createFileRoute('/admin/organizations/$organizationId/auction-limits/')({
  params: {
    parse: v => paramsSchema.parse(v),
  },
  component: RouteComponent,
  beforeLoad: ({ params }) => {
    // Detail kvůli názvu firmy, stavu funkce a seznamu portálů
    const organizationId = paramsSchema.parse(params).organizationId;
    useAdminOrganizationDetailStore.getState().loadOrganizationDetail(organizationId);
  },
});

function RouteComponent() {
  const { organizationId } = Route.useParams();
  return <OrganizationAuctionLimitsPage organizationId={organizationId} />;
}
